// extracted by mini-css-extract-plugin
export default {"main":"error-page_main__hU64G","container":"error-page_container__B8eeF","title":"error-page_title__pisXB","button":"error-page_button__li5O3"};